import { useEffect } from "react";
import { NotificationManager } from "../../../notifications/NotificationManager";
import { useApp } from "../../../context/AppContextProvider";
import { useAuth } from "../../../context/UserContextProvider";
import i18n from "../../../language/i18n";
import ErrorLayout from "../../../components/common/error/ErrorLayout";

const AccountActivationErrorScreen = () => {
  const { setBoarding, isFullScreen, setIsFullScreen } = useApp();
  const { handleStateLogout } = useAuth();

  useEffect(() => {
    if (isFullScreen === false) {
      setIsFullScreen(true);
    }
  }, []);

  const handleClickToNavigate = () => {
    handleStateLogout();
    setBoarding("LANDING");
    NotificationManager.success(i18n.t("logout_successful_text"));
  };

  return (
    <ErrorLayout
      statusCode={"400"}
      statusText={i18n.t("account_activation_status_text")}
      helpText={i18n.t("account_activation_help_text")}
      tone="warning"
      icon="send"
      actionTitle={i18n.t("login")}
      onAction={handleClickToNavigate}
    />
  );
};

export default AccountActivationErrorScreen;
